import * as types from '@/store/types'
import { DASHBOARD_ENTRY_ROUTE_NAME } from '@/constants/routes'
import { redirectToBackOrHome } from '@/utils/common'

// Загрузка списка аккаунтов
export default function loadAccountList({ from, next, store }) {
  store
    .dispatch(types.ADD_ACTION_IN_QUEUE, {
      type: types.GET_ACCOUNT_LIST,
      name: types.SESSION
    })
    .then(() => {
      const { accounts } = store.state[types.SESSION].model
      // Если существует более 1-го аккаунта
      if (accounts.length > 1 || accounts.length === 0) {
        next()
        return
      }

      // Если аккаунт всего один, то выбираем его
      if (accounts.length === 1) {
        // TODO: придумать, как избавиться от копипасты
        const { directLogin } = accounts[0]
        const user = store.state[types.SESSION].model
        const { id: userId, username } = user
        const payload = { directLogin, userId, username }

        store.commit(types.UPDATE_MODEL, { name: types.SESSION, model: { user: payload } })
        store
          .dispatch(types.ADD_ACTION_IN_QUEUE, {
            type: types.SELECT_ACCOUNT,
            payload,
            name: types.SESSION
          })
          .catch(() => {
            store.commit(types.SET_MODEL, { name: types.SESSION, model: { user } })
          })
        next({ name: DASHBOARD_ENTRY_ROUTE_NAME })
        return
      }

      // Возвращаем обратно, если возможно
      redirectToBackOrHome(from, next)
    })
    .catch(() => {
      // Возвращаем обратно, если возможно
      redirectToBackOrHome(from, next)
    })
}
